var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-element-loading',{attrs:{"active":true,"is-full-screen":"","spinner":"bar-fade-scale","text":"Session Expired. Please Login Again"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }